import React, {useMemo} from 'react'
import styled from 'styled-components'
import {WINDOW_MODE_TABLET_WIDTH} from 'consts'
import {TemplateAuthAccessFullPage} from 'pages'
import {useWindowMode} from 'windows'
import {Icon, Modal} from 'common/components'
import convertUnit from 'lib/unit'

const StyledModal = styled(Modal)`
  width: 100%;
`
const StyledDesktopModal = styled(Modal)`
  width: ${convertUnit(375)};
  padding: ${convertUnit(25)};
`

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    padding: ${convertUnit(25)} 0;
    padding-bottom: 0;
  }
`

const StyledIconContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    padding-right: ${convertUnit(25)};
  }
`

const StyledCloseIcon = styled.div`
  cursor: pointer;
`

export interface ModalPortalGuestItemProps {
  onClose(): void
}

export default function ModalPortalGuestItem({
  onClose,
}: ModalPortalGuestItemProps) {
  const mode = useWindowMode()

  const handleRenderCloseIcon = useMemo(
    () => (
      <StyledIconContainer>
        <StyledCloseIcon>
          <Icon
            type="close"
            color="primary_5"
            size={convertUnit(20)}
            onClick={onClose}
          />
        </StyledCloseIcon>
      </StyledIconContainer>
    ),
    [onClose],
  )

  const handleRenderContent = useMemo(
    () => (
      <StyledContainer>
        {handleRenderCloseIcon}
        <TemplateAuthAccessFullPage onClose={onClose} />
      </StyledContainer>
    ),
    [handleRenderCloseIcon, onClose],
  )

  return mode === 'mobile' ? (
    <StyledModal
      zIndex={10}
      visible
      isHalfScreen
      noBorderRadius
      onBackdropPress={onClose}>
      {handleRenderContent}
    </StyledModal>
  ) : (
    <StyledDesktopModal zIndex={10} visible onBackdropPress={onClose}>
      {handleRenderContent}
    </StyledDesktopModal>
  )
}
